module.exports = __webpack_public_path__ + "static/360view_50m-269b60293771260104466deb81b05810.jpg";